import React, { Fragment, useState, forwardRef, useImperativeHandle } from 'react'

const StaticAlert = forwardRef((props, ref) => {
    const [isClosed, setClose] = useState(props.isClosed)
    const [msg, setMessage] = useState(props.message)
    const [type, setType] = useState(props.type)

    useImperativeHandle(ref, () => ({
        showAlert(msg = "", type = "default") {
            setClose(false)
            setType(type)
            setMessage(msg)
        }
    }))

    function handleCloseAlert() {
        setClose(true)
    }

    return (
        <Fragment>
            {type === "error" && !isClosed &&
                <div className="alert alert-danger alert-dismissible">
                    <button type="button" onClick={handleCloseAlert} className="close" aria-hidden="true">×</button>
                    {msg}
                </div>
            }
            {type === "success" && !isClosed &&
                <div className="alert alert-success alert-dismissible">
                    <button type="button" onClick={handleCloseAlert} className="close" aria-hidden="true">×</button>
                    {msg}
                </div>
            }
            {type === "default" && !isClosed &&
                <div>{msg}</div>
            }
        </Fragment>
    )
})

StaticAlert.defaultProps = {
    type: "default",
    message: "",
    isClosed: false
}

export default StaticAlert
